module.exports = __webpack_public_path__ + "img/bj47.a8379064.png";